export default "__VITE_ASSET__VktWwkKk__"